import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useShallow } from "zustand/react/shallow";
import { trpc } from "~/api/trpc";
import { useUserStore } from "~/stores/user-store";
import useAuth from "~/auth/useAuth";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const UserStoreHydrator = () => {
    const { logout } = useAuth();
    const { user, setUser } = useUserStore(
        useShallow((state) => ({
            user: state.user,
            setUser: state.setUser,
        }))
    );

    const userDataQuery = trpc.user.getMe.useQuery(undefined, {
        staleTime: 15 * 1000, // 15 seconds
        gcTime: 15 * 1000, // 15 seconds cache
        refetchInterval: 15 * 1000, // 15 seconds
        refetchOnReconnect: true,
        refetchIntervalInBackground: true,
        refetchOnWindowFocus: true,
        refetchOnMount: true,
        retry: true,
        retryDelay: 1500,
    });

    const trpcUtils = trpc.useUtils();

    const [isReconnectingToastId, setIsReconnectingToastId] = useState<string | number | null>(null);

    useEffect(() => {
        if (userDataQuery.data) {
            const lastUser = user;
            const newUser = userDataQuery.data;
            if (JSON.stringify(lastUser) !== JSON.stringify(newUser)) {
                setUser({
                    ...newUser,
                    timezone: newUser.timezone,
                });
            }
        }
    }, [userDataQuery.data]);

    useEffect(() => {
        if(userDataQuery.failureCount >= 3 && !isReconnectingToastId) {
            const id = toast.warning("Reconnecting to server...", {duration: 5 * 60 * 1000,  icon: <Loader2 className='animate-spin' />});
            setIsReconnectingToastId(id);
        }
        if(isReconnectingToastId && userDataQuery.failureCount === 0) {
            // Successful reconnection
            toast.dismiss(isReconnectingToastId);
            toast.success("Connection re-established!");
            setIsReconnectingToastId(null);
            trpcUtils.invalidate(); // This refetches all current queries that may have been failing during the disconnect.
        }
        // console.log("failure count", userDataQuery.failureCount)
        // console.log(JSON.stringify(userDataQuery.failureReason, null, 4));
    }, [userDataQuery.failureCount]);

    useEffect(() => {
        if(user?.timezone) {
            // console.log("updating user timezone to: " + user.timezone)
            const timezoneString = user.timezone; // Should be this type of format: "Europe/Berlin"
            dayjs.tz.setDefault(timezoneString);
        }
    }, [user?.timezone]);

    return (
        <div className='hidden' />
    )
}

export default UserStoreHydrator